// Inline nav icons for the v2 «asphalt» header, matching the CleverParking
// reference style (16px, stroked, currentColor). Keyed by section id.
// NB: solid strokes only — no dashed/dotted paths.

const svg = (children) => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    {children}
  </svg>
);

const ICONS = {
  // Мнемосхема — dashboard grid
  scheme: svg(
    <>
      <rect x="1.8" y="1.8" width="5.2" height="5.2" rx="1.4" />
      <rect x="9" y="1.8" width="5.2" height="5.2" rx="1.4" />
      <rect x="1.8" y="9" width="5.2" height="5.2" rx="1.4" />
      <rect x="9" y="9" width="5.2" height="5.2" rx="1.4" />
    </>
  ),
  // Парковки — parking "P" sign
  stays: svg(
    <>
      <rect x="2" y="2" width="12" height="12" rx="3" />
      <path d="M6 11.5V4.5h2.6a2.3 2.3 0 0 1 0 4.6H6" />
    </>
  ),
  // Клиенты — people
  clients: svg(
    <>
      <circle cx="6" cy="5.4" r="2.3" />
      <path d="M2.3 12.8c0-2 1.7-3.3 3.7-3.3s3.7 1.3 3.7 3.3" />
      <path d="M11 4.2a2.1 2.1 0 0 1 0 4.1" />
      <path d="M11.3 9.6c1.6.2 2.6 1.3 2.6 3" />
    </>
  ),
  // Средства оплаты — card
  payments: svg(
    <>
      <rect x="1.5" y="3.5" width="13" height="9" rx="1.6" />
      <path d="M1.5 6.6h13" />
      <path d="M4 10h3" />
    </>
  ),
  // Журналы и отчёты — document with lines
  reports: svg(
    <>
      <path d="M3.5 1.7h5.7l3.3 3.3v9.3H3.5z" />
      <path d="M9 1.7v3.4h3.3" />
      <path d="M5.6 8.5h4.8M5.6 11h4.8" />
    </>
  ),
  // Настройки — sliders
  options: svg(
    <>
      <path d="M2 4.6h6.2M11.6 4.6h2.4" />
      <circle cx="9.7" cy="4.6" r="1.6" />
      <path d="M2 11.4h2.4M7.8 11.4h6.2" />
      <circle cx="5.9" cy="11.4" r="1.6" />
    </>
  ),
};

// Fallback — a small dot marker for any unmapped section.
const fallback = svg(<circle cx="8" cy="8" r="3" />);

export const getNavIcon = (id) => ICONS[id] || fallback;
